import axiosInstance from "../axios";

// Ticket Management
export const getTicket = async (ticketId) => {
  return axiosInstance.get(`/tickets/${ticketId}`);
};

export const updateTicket = async (ticketId, payload) => {
  return axiosInstance.patch(`/tickets/${ticketId}`, payload);
};

export const closeTicket = async (ticketId, cost) => {
  return axiosInstance.patch(`/tickets/${ticketId}/close`, { cost });
};

// Impacted Parts Management
export const addImpactedPart = async (ticketId, formData) => {
  return axiosInstance.post(`/tickets/${ticketId}/impacted_parts`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateImpactedPart = async (impactedPartId, formData) => {
  return axiosInstance.patch(`/impacted_parts/${impactedPartId}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateImpactedPartStatus = async (impactedPartId, status, analysis = null) => {
  return axiosInstance.patch(`/impacted_parts/${impactedPartId}/update_status`, {
    status,
    analysis,
  });
};

export const deleteImpactedPart = async (impactedPartId) => {
  return axiosInstance.delete(`/impacted_parts/${impactedPartId}`);
};

// Helper endpoints
export const getPartByLabel = async (orderId, label) => {
  return axiosInstance.get(`/orders/${orderId}/part_by_label`, {
    params: { label: label }
  });
};

export const getTicketConstants = async () => {
  return axiosInstance.get(`/tickets/constants`);
};

